import { Icon } from "@iconify/react"
import { Button, Card, Table } from "antd"
import { useEffect } from "react";
import { useNavigate } from "react-router";
import useTitleStore from "../../../store/titleStore";
import { useTableHeight } from "../../../hooks/useTableHeight";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ratePerParameterService } from "../../../services/rate-per-parameter.service";
import UpdatedByCell from "../../../components/UpdatedByCell";

export default function RatePerParemeterIndex(){

  const navigate = useNavigate();
  const { setTitle } = useTitleStore();
  const tableHeight = useTableHeight();

  useEffect(() => {
    setTitle("Layanan Lab - Tarif Per Parameter");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: service , isLoading } = useQuery({
    queryKey: ['services'],
    queryFn: () => ratePerParameterService.fetchAll(),
    placeholderData: keepPreviousData,
  })

  const columns = [
    {
      title: 'No',
      align: 'center',
      width: 80,
      render: (text, record, index) =>  index + 1,
      // fixed: 'left'
    },
    {
      title: 'Layanan',
      dataIndex: 'name',
      width: 210,
    },
    {
      title: 'Updated By',
      width: 210,
      // minWidth: 120,
      render: val => <UpdatedByCell value={val} />,
    },
    {
      className: 'last-cell-p',
      title: 'Aksi',
      align: 'right',
      width: 80,
      fixed: 'right',
      render: record => (
        <Button 
          variant="filled" 
          color="primary"
          icon={<Icon icon="solar:pen-2-bold-duotone" width="18" height="18" />}
          size=""
          onClick={() => navigate(`/lab-service/rate-per-parameter/detail/${record.id}`)}
        />
      )
    },
  ]

  return (
    <Card
      styles={{
        body: {
          paddingLeft: 0,
          paddingRight: 0
        }
      }}
    >
      <Table
        loading={isLoading}
        columns={columns}
        pagination={false}
        size="small"
        rowKey={'id'}
        scroll={{ y: tableHeight }}
        dataSource={service?.data}
      />
    </Card>
  )
}